import { supabase } from '../../shared/supabase/supabaseClient';
import type { SyncQueueItem } from '../../sync/core/syncTypes';
import { toFlushErr, toFlushOk, type FlushRpcResult } from '../../sync/core/rpcHelpers';

export const applyCashSessionViaRpc = async (item: SyncQueueItem): Promise<FlushRpcResult> => {
  const { error } = await supabase.schema('pos').rpc('apply_cash_session_command', {
    p_operation: item.operation,
    p_payload: item.payload,
  });
  if (error) return toFlushErr(error);
  await completeCashSessionAfterServerApply(item);
  return toFlushOk();
};

/** Post-apply hook for sync flush. ADR-017: no local SQLite mirror to mark synced. */
export async function completeCashSessionAfterServerApply(_item: SyncQueueItem): Promise<void> {
  // Intentionally empty — server is authority; no local sync_state row.
}
